import { render, staticRenderFns } from "./CompleteAnswerPaper.vue?vue&type=template&id=04d6a371"
import script from "./CompleteAnswerPaper.vue?vue&type=script&lang=js"
export * from "./CompleteAnswerPaper.vue?vue&type=script&lang=js"
import style0 from "./CompleteAnswerPaper.vue?vue&type=style&index=0&id=04d6a371&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports